import { FormikProvider, useFormik } from 'formik';
import * as yup from 'yup';
import { preventFormDefault } from '@/modules/common/utils/preventFormDefault.ts';
import { useIssuerUpdateEntityStatusMutation } from '@/modules/issuer-dashboard/queries/entities.ts';
import { BaseModalProps, Button, ModalContentWrapper, TextInputField } from 'ui';
import { EntityStatus, UpdateEntityStatusRequest } from 'api';

const validationSchema = yup.object({
  entity_application_rejection_reason: yup.string().trim().required('Decline reason is required'),
});

interface IssuerRejectEntityModalProps extends BaseModalProps {
  id: number;
}

export const IssuerRejectEntityModal = ({ open, onClose, id }: IssuerRejectEntityModalProps) => {
  const formik = useFormik<UpdateEntityStatusRequest>({
    initialValues: {
      id,
      status: EntityStatus.EntityUnsuccessfull,
      entity_application_rejection_reason: '',
    },
    validateOnBlur: false,
    validateOnChange: false,
    validateOnMount: false,
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      await rejectEntity(values);
      resetForm();
      onClose();
    },
    enableReinitialize: true,
  });

  const { mutateAsync: rejectEntity } = useIssuerUpdateEntityStatusMutation();

  const handleClose = () => {
    formik.resetForm();
    onClose();
  };

  return (
    <ModalContentWrapper open={open} title="Decline reason" onClose={handleClose}>
      <FormikProvider value={formik}>
        <form className="w-full flex flex-col space-y-10" onSubmit={preventFormDefault}>
          <div className="w-full flex flex-col space-y-8">
            <TextInputField
              name="entity_application_rejection_reason"
              placeholder="Some reason..."
              textarea
            />
          </div>
          <Button onClick={formik.submitForm} loading={formik.isSubmitting}>
            Decline
          </Button>
        </form>
      </FormikProvider>
    </ModalContentWrapper>
  );
};
